import { Injectable } from "@angular/core";
import { AuthProvider } from "../auth/auth";
import { AppConfig } from "../../config/app.config";
import { Product } from "../../models/product";
import { DataProvider } from "../data/data";
import { Sorting, By } from "../sorting/sorting";

@Injectable()
export class ProductProviderMock {

    constructor() {
    }

    products: Array<Product>;

    async getProducts(): Promise<Array<Product>> {
        var x = new Array<Product>();
        if (this.products) {
            x = this.products;
        } else {
            for (var index = 0; index < 40; index++) {
                var c = new Product();
                c.id = index;
                c.name = `Product ${index}`;
                c.category_id = 3;
                c.price_excluding_vat = index;
                c.image = "https://i.ytimg.com/vi/yaqe1qesQ8c/maxresdefault.jpg";
                x.push(c);
            }
            this.products = x;
        }
        return x;
    }

    async getProductByBarcode(barcode: string): Promise<Product> {
        var x = await this.getProducts();
        var rnd = Math.floor(Math.random() * ((x.length - 1) - 0)) + (x.length - 1);
        return x[rnd];
    }

    async getProductsByCategory(categoryId: number): Promise<Array<Product>> {
        return (await this.getProducts()).filter(x => x.category_id == categoryId);
    }

    async getProduct(id: Number): Promise<Product> {
        return (await this.getProducts()).find(x => x.id == id);
    }
}





// WEBPACK FOOTER //
// ./src/providers/product/product-mock.ts